import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {ConfigurationProfilesDialogsService} from "../../services/configuration-profiles-dialogs-service.service";
import {AgentConfigurationProfilesService} from "../../services/agent-configuration-profiles-service.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AgentPairingType} from "../../../agents/types/agentPairing.type";
import {AgentValidationType} from "../../../agents/types/agentValidation.type";
import {AgentConfigurationProfileModel} from "../../models/agent-configuration-profile.model";
import {
  AgentClockInProviderPreferencesModel,
  AgentShiftCompensationPreferencesModel,
  AgentShiftCompensationProviderType,
  AgentShiftRestrictionsModel,
  AgentTimekeepingPreferencesModel,
  ClockInOnResourceEndType,
  GapClassification,
  AgentInShiftBehaviorPreferencesModel
} from "../../models/agent-shift-restrictions.model";
import {AgentGeneralPreferencesModel, OwnershipPreferencesModel} from "../../models/agent-general-preferences.model";
import {NotificationsPreferencesModel, StationaryNotificationPreferencesModel} from "../../models/agent-app-preferences.model";
import {AgentRequests} from "../../../agents/services/agent-requests.service";
import {AgentModel} from "../../../agents/angular/models/agent.model";
import {QuoteType} from "../../../fulfillment/types/quote.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentType} from "../../../agents/types/agent.type";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {RelationType} from "../../../commons/types/relation.type";
import {PackageFieldOptionType} from "../../../agents/types/packageFieldOption.type";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";
import {GroupByPackagePreferences} from "../../types/group-by-package-preferences.interface";
import {FieldType} from "../../../site-preferences/types/field.type";
import {ClockInResourceProviderType} from "../../../timekeeping/angular/models/planned-resource.model";
import {TimekeepingFrequencyType} from "../../../timekeeping/angular/models/payment-cycle.model";
import {ResourceScopeType} from "../../../agents/types/resourceScope.type";
import {BreakType} from "../../../site-preferences/models/break-type.model";
import {AppDefaultTaskViewType} from "../../types/app-default-task-view.type";
import {CreateServiceLocationSourceType} from "../../types/create-service-location-source.type";

export class agentConfigurationProfileViewCtrl implements IController {

  configurationProfile: AgentConfigurationProfileModel;
  agent: AgentModel;
  agentIds: any;
  defaultProfileId: any;
  selectedTab: string;
  isAgentProfile: boolean;

  public siteDistanceUnit: string;
  public breakTypes: BreakType[];
  private pairingOptions: any = {None: "None", ProNumber: "ProNumber", Barcode: "Barcode"};
  private packageFieldOptions: PackageFieldOptionType[] = Object.values(PackageFieldOptionType);
  private validationOptions: any = {None: "None", Barcode: "Barcode", ProNumber: "ProNumber", Click: "Click"}
  public agentValidationTypesMap: typeof AgentValidationType = AgentValidationType;
  public packageFieldOptionTypesMap: typeof PackageFieldOptionType = PackageFieldOptionType;
  private profileCopy: AgentConfigurationProfileModel;
  private isMobile: boolean;
  private isFooterDisplayed: boolean;
  private isCardExpanded: any;
  private agentsTotal: number;
  public quoteTypes: QuoteType[];
  public agentTypes: typeof AgentType = AgentType;
  public relationTypes: typeof RelationType = RelationType;
  public customFields: any[];
  public isTimekeepingEnabled: boolean;
  public timekeepingDisplayValues: any;
  public breakOptions: any;
  public appDefaultTaskViewTypeOptions: AppDefaultTaskViewType[];
  public createServiceLocationSourceOptions: CreateServiceLocationSourceType[];

  /* @ngInject */
  constructor(private agentConfigurationProfilesService: AgentConfigurationProfilesService, private $state,
              private $window: IWindowService, private bringozToastService: BringozToastService,
              private commonsDialogService: CommonsDialogService, private commonsAlertsService: CommonsAlertsService,
              private configurationProfilesDialogsService: ConfigurationProfilesDialogsService, private splitService: SplitService,
              private $mdMedia, private agentsService: AgentsService, private agentRequests: AgentRequests,
              private settingsService: SettingsService) {
    this.siteDistanceUnit = splitService.getSiteDistanceSmallUnit();
    this.breakTypes = splitService.getBreakTypes();
    this.customFields = splitService.getCustomPackageFields().filter((cf) => {
      return cf.type !== FieldType.DropdownMultiple;
    })
  }

  $onInit() {

    this.quoteTypes = Object.values(QuoteType);
    this.isMobile = !this.$mdMedia('gt-md');
    this.isTimekeepingEnabled = this.splitService.isTimekeepingEnabled();
    this.breakOptions = {
      list: this.breakTypes?.map(b => {
        return {id: b.id, name: b.name}
      }), propertyRef: 'name'
    };
    this.appDefaultTaskViewTypeOptions = Object.values(AppDefaultTaskViewType);
    this.createServiceLocationSourceOptions = Object.values(CreateServiceLocationSourceType);
    this.isCardExpanded = {
      generalPreferences: false,
      geofencingPreferences: false,
      pairingPreferences: false,
      breakPreferences: false,
      routeCostPreferences: false,
      auctionPreferences: false,
      modulePreferences: false,
      itineraryPreferences: false,
      relatedServiceAbortRules: false,
      routeSelfAssignPreferences: false,
      serviceSelfAssignPreferences: false,
      serviceCreationPreferences: false,
      agentValidationPreferences: false,
      agentClockInPreferences: false,
      agentClockInProviderPreferences: false,
      agentTimekeepingPreferences: false,
      agentShiftCompensationPreferences: false,
      agentInShiftBehaviorPreferences: false,
      agentMobileUxPreferences: false,
      agentNotificationPreferences: false,
      agentRecordRestrictionPreferences: false,
      agentShiftAssignmentPreferences: false
    }
    this.isFooterDisplayed = false;

    this.profileCopy = angular.copy(this.configurationProfile);

    this._initializeConfigurationProfile();

    // getting amount of assigned agents:
    this.agentsService.getAgentTotalsByConfigurationId(this.configurationProfile.id)
      .then((agentsTotal: any) => {
        this.agentsTotal = agentsTotal.total;
      })
  }

  // this.blockedRelations = _.filter(this.relations, (relation) => {
  //   return relation.type === "BlockedBy";
  // })
  // this.blockingRelations = _.filter(this.relations, (relation) => {
  //   return relation.type === "Blocking";
  // })
  // this.supplyTogetherRelations = _.filter(this.relations, (relation) => {
  //   return relation.type === "SupplyTogether";
  // })
  // this.referencesRelations = _.filter(this.relations, (relation) => {
  //   return relation.type === "References";
  // })
  // this.referenceByRelations = _.filter(this.relations, (relation) => {
  //   return relation.type === "ReferencedBy";
  // })

  $onChanges(changes) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.agent = changes.agent.currentValue;
      this.configurationProfile = changes.agent.agentConfigurationProfile;
    }
  }

  onUpdateInfo(profile, event) {
    this.isAgentProfile ? this.onUpdateAgentProfileInfo(profile, event) : this.onUpdateProfileInfo(profile, event);
  }

  onUpdateProfileInfo(profile, event) {
    this.configurationProfilesDialogsService.editAgentProfileInfo(profile, this.agentIds, event, undefined, [this.agentTypes.Driver, this.agentTypes.ServiceAgent, this.agentTypes.Manager])
      .then((payload) => {
        if (!_.isEqual(this.agentIds, payload.agentIds)) {
          const agentIdsRemoved = _.difference(this.agentIds, payload.agentIds);
          if (agentIdsRemoved.length) {
            this.onAssignAgentsToDefaultProfile(agentIdsRemoved);
          }
          if (payload.agentIds.length) {
            this.onAssignAgentsToProfile(profile.id, payload.agentIds, false);
          }
        }
        if (!_.isEqual(this.configurationProfile, payload.updatedProfile)) {
          this.onUpdateProfile(payload.updatedProfile);
        }
      })
  }

  onUpdateAgentProfileInfo(profile, event) {
    this.configurationProfilesDialogsService.editAgentProfileInfo(profile, undefined, event, this.agent, [this.agentTypes.Driver, this.agentTypes.ServiceAgent, this.agentTypes.Manager])
      .then((payload) => {
        if (!_.isEqual(this.configurationProfile, payload.updatedProfile)) {
          this.onUpdateAgentProfile(payload.updatedProfile);
        }
      })
  }

  onSelectChange(value, group, subGroup, property) {
    if (!this.profileCopy[group]) {
      this.profileCopy[group] = {};
    }

    if (!this.profileCopy[group][subGroup]) {
      this.profileCopy[group][subGroup] = {};
    }

    _.set(this.profileCopy[group][subGroup], property, value);
    this.onEditItem();
  }

  onChangePercentage(value, group, subGroup, property) {
    if (!this.profileCopy[group]) {
      this.profileCopy[group] = {};
    }

    if (!this.profileCopy[group][subGroup]) {
      this.profileCopy[group][subGroup] = {};
    }

    _.set(this.profileCopy[group][subGroup], property, value);
    this.onEditItem();
  }

  onToggleIgnoreValidations() {
    if (!this.profileCopy.appPreferences.validationsPreferences.ignoreValidations) {
      this.profileCopy.appPreferences.validationsPreferences.ignoreValidationOption = undefined;
    }

    this.onEditItem();
  }

  onStaticAgentChange(enabled: boolean) {
    if (this.profileCopy.appPreferences?.notificationsPreferences?.stationaryNotificationPreferences) {
      this.profileCopy.appPreferences.notificationsPreferences.stationaryNotificationPreferences.createServiceInAppNotification = enabled;
    }
    this.onEditItem()
  }

  onEditItem() {
    if (!_.isEqual(this.configurationProfile, this.profileCopy)) {
      this.isFooterDisplayed = true;
    }
  }

  onTimekeepingDisplayChange() {
    const tkPref = this.profileCopy.shiftRestrictions.agentTimekeepingPreferences;
    const display = this.timekeepingDisplayValues;
    tkPref.driveTimeThresholdMillis = (display.driveTimeThresholdMinutes || 0) * 60000;
    tkPref.adjustedStartTimeDeviationThresholdMillis = (display.adjustedStartTimeDeviationThresholdMinutes || 0) * 60000;
    tkPref.adjustedEndTimeDeviationThresholdMillis = (display.adjustedEndTimeDeviationThresholdMinutes || 0) * 60000;
    tkPref.geoTimeMismatchThresholdMillis = (display.geoTimeMismatchThresholdMinutes || 0) * 60000;
    tkPref.dwellTimeThresholdMillis = (display.dwellTimeThresholdMinutes || 0) * 60000;
    this.onEditItem();
  }

  onEnableAbortOfRelatedServicesChange() {
    if (!this.profileCopy.itineraryPreferences.abortRelationTypes) {
      this.profileCopy.itineraryPreferences.abortRelationTypes = [];
    }

    this.onEditItem();
  }

  onSave(profile, form, event) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid && this.validateCustomFieldSelection(profile)) {
        this.isAgentProfile ? this.onUpdateAgentProfileInfo(profile, event) : this.onUpdateProfile(profile);
      }
    }
  }

  validateCustomFieldSelection(profile) {
    if (profile.generalPreferences?.groupByPackagePreferences?.packageGroupType === PackageFieldOptionType.Custom) {
      if (!profile.generalPreferences?.groupByPackagePreferences?.customFieldId) {
        const message = {
          body: 'CUSTOM_FIELD_REQUIRED_ERROR'
        };
        this.bringozToastService.error(message);
        return false;
      }
    }
    return true;
  }

  onUpdateProfile(profile) {
    this.agentConfigurationProfilesService.updateOne(profile)
      .then((updatedProfile: AgentConfigurationProfileModel) => {
        this.configurationProfile = updatedProfile;
        this.$onInit();
      })
  }

  onUpdateAgentProfile(profile) {
    this.agentConfigurationProfilesService.updateAgentProfile(profile, this.agent.id)
      .then((updatedAgent: any) => {
        this.agent = updatedAgent;
        this.configurationProfile = updatedAgent.agentConfigurationProfile;

        this.$onInit();
      })
  }

  onAssignAgentsToProfile(profileId, agentIds, isDuplicated) {
    this.agentsService.assignConfigurationProfile(profileId, agentIds)
      .then((agents: any) => {
        this.agentsTotal = agents.length;
        const agentsRef = angular.copy(agents);
        this.agentIds = _.map(agentsRef, (agent: any) => {
          return agent.id;
        });
      }).then(() => {
      if (isDuplicated) {
        this.$state.go('site-administration.agent-configuration-profile', {id: profileId});
      }
    })
  }

  onAssignAgentsToDefaultProfile(agentIds) {
    this.agentsService.assignConfigurationProfile(this.defaultProfileId, agentIds)
      .then((agents: AgentModel[]) => {
        this.profileCopy = angular.copy(this.configurationProfile);
        this.agentsTotal = agents.length;
      })
  }

  onCancelUpdateProfile() {
    this.profileCopy = angular.copy(this.configurationProfile);

    // Initialize profileCopy
    this._initializeConfigurationProfile();

    this.isFooterDisplayed = false;
  }

  onDelete(profileId) {
    this.agentConfigurationProfilesService.deleteOne(profileId)
      .then((removedProfile) => {
        this.$state.go('site-administration.configuration-profiles');
      })
  }

  onUploadJSON(event) {
    this.commonsDialogService.uploadJSON(event)
      .then((validConfigurationProfile: AgentConfigurationProfileModel) => {
        if (!!validConfigurationProfile?.agentType &&
          validConfigurationProfile?.appPreferences &&
          validConfigurationProfile?.generalPreferences &&
          validConfigurationProfile?.itineraryPreferences &&
          validConfigurationProfile?.shiftRestrictions) {
          this.profileCopy.appPreferences = validConfigurationProfile.appPreferences;
          this.profileCopy.generalPreferences = validConfigurationProfile.generalPreferences;
          this.profileCopy.itineraryPreferences = validConfigurationProfile.itineraryPreferences;
          this.profileCopy.shiftRestrictions = validConfigurationProfile.shiftRestrictions;
          this.onEditItem()
        } else {
          this.commonsAlertsService.updateJsonMismatchError();
        }
      })
  }

  onCopyJSON() {
    const text = JSON.stringify(this.configurationProfile)
    this.$window.navigator.clipboard.writeText(text).then((succ) => {
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }

  onDuplicate(configurationProfile, event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(configurationProfile, event, true)
      .then((payload) => {
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(payload.newProfile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.onAssignAgentsToProfile(newProfile.id, payload.agentIds, false);
            }
            this.$state.go('site-administration.agent-configuration-profile', {id: newProfile.id});
          })
      })
  }

  onPairingOptionChange(pairingOption) {
    if (pairingOption === AgentPairingType.Barcode) {
      this.profileCopy.appPreferences.pairingPreferences.quickValidation = false;
      this.validationOptions = [AgentValidationType.None, AgentValidationType.Barcode, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.profileCopy.appPreferences.pairingPreferences.validationOption)) {
        this.profileCopy.appPreferences.pairingPreferences.validationOption = AgentValidationType.Barcode;
      }
    } else if (pairingOption === AgentPairingType.None) {
      this.validationOptions = angular.copy(Object.values(AgentValidationType));
      this.profileCopy.appPreferences.pairingPreferences.forcePairing = false;
    } else if (pairingOption === AgentPairingType.ProNumber) {
      this.validationOptions = [AgentValidationType.None, AgentValidationType.ProNumber, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.profileCopy.appPreferences.pairingPreferences.validationOption)) {
        this.profileCopy.appPreferences.pairingPreferences.validationOption = AgentValidationType.ProNumber;
      }
    }
    this.onEditItem();
  }

  onPackageFieldOptionChanged(packageFieldChanged) {
    if (packageFieldChanged !== PackageFieldOptionType.Custom) {
      if (this.profileCopy.generalPreferences?.groupByPackagePreferences) {
        delete this.profileCopy.generalPreferences.groupByPackagePreferences.customFieldId;
      }
      this.onEditItem();
    }
  }

  onCustomFieldChanged(customFieldId) {
    if (!this.profileCopy.generalPreferences) {
      this.profileCopy.generalPreferences = {} as AgentGeneralPreferencesModel;
    }
    if (!this.profileCopy.generalPreferences.groupByPackagePreferences) {
      this.profileCopy.generalPreferences.groupByPackagePreferences = {} as GroupByPackagePreferences;
    }
    this.profileCopy.generalPreferences.groupByPackagePreferences.customFieldId = customFieldId;
    this.onEditItem();
  }


  onChangeValidateBy(validationOption, propertyName) {
    this._setPairingOptions();

    if (validationOption === AgentValidationType.Barcode) {
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.Barcode;
      }
    } else if (validationOption === AgentValidationType.ProNumber) {
      this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.ProNumber;
    } else if (validationOption === AgentValidationType.None) {
      this.profileCopy.appPreferences.pairingPreferences.quickValidation = false;
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.None;
      }
    } else if (validationOption === AgentValidationType.Click) {
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = AgentPairingType.None;
      }
    }
    this.onEditItem();
  }

  onForcePairingChange(forcePairing) {
    if (!!forcePairing) {
      this.pairingOptions = [AgentPairingType.ProNumber, AgentPairingType.Barcode];
      if (!_.includes(this.pairingOptions, this.profileCopy.appPreferences.pairingPreferences.pairingOption)) {
        this.profileCopy.appPreferences.pairingPreferences.pairingOption = this.pairingOptions[0];
      }
    }
    this.onEditItem();
  }

  onChangeEnableAgentAssistant(enableAgentAssistant: boolean) {
    this.profileCopy.generalPreferences.ownershipPreferences = enableAgentAssistant ? {} as OwnershipPreferencesModel : undefined;
    this.onEditItem();
  }

  onEnableActionsForAgentAssistantsChange(enableActionsForAgentAssistants: boolean) {
    if (!enableActionsForAgentAssistants) {
      this.profileCopy.generalPreferences.ownershipPreferences.enableTakeTaskOwnership = false;
    }

    this.onEditItem();
  }

  onEnableTakeTaskOwnershipChange() {
    if (!this.profileCopy.generalPreferences.ownershipPreferences.enableActionsForAgentAssistants) {
      this.profileCopy.generalPreferences.ownershipPreferences.enableTakeTaskOwnership = false;
    }
    this.onEditItem();
  }

  onSelectBreakTypeOptions(breakTypeIds) {
    if (breakTypeIds?.length < 1) {
      this.commonsAlertsService.invalidSelectionInfo();
      return;
    }
    this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.breakTypeIds = breakTypeIds;
    this.onEditItem();
  }

  onDefaultTaskViewChange(defaultTaskView: AppDefaultTaskViewType) {
    this.profileCopy.generalPreferences.defaultTaskView = defaultTaskView;
    this.onEditItem();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _initializeConfigurationProfile() {
    if (!this.profileCopy.generalPreferences) {
      this.profileCopy.generalPreferences = {} as AgentGeneralPreferencesModel;
    }
    if (!this.profileCopy.appPreferences.notificationsPreferences) {
      this.profileCopy.appPreferences.notificationsPreferences = {} as NotificationsPreferencesModel;
    }
    if (!this.profileCopy.appPreferences.notificationsPreferences.stationaryNotificationPreferences) {
      this.profileCopy.appPreferences.notificationsPreferences.stationaryNotificationPreferences = {} as StationaryNotificationPreferencesModel;
    }
    if (!this.profileCopy.itineraryPreferences.abortRelationTypes) {
      this.profileCopy.itineraryPreferences.abortRelationTypes = [];
    }
    if (!this.profileCopy.generalPreferences.groupByPackagePreferences) {
      this.profileCopy.generalPreferences.groupByPackagePreferences = {} as GroupByPackagePreferences;
    }
    if (!this.profileCopy.generalPreferences.groupByPackagePreferences.packageGroupType) {
      this.profileCopy.generalPreferences.groupByPackagePreferences.packageGroupType = PackageFieldOptionType.Barcode;
    }
    if (this.profileCopy.generalPreferences.groupByPackagePreferences.enablePackageGrouping === undefined ||
      this.profileCopy.generalPreferences.groupByPackagePreferences.enablePackageGrouping === null) {
      this.profileCopy.generalPreferences.groupByPackagePreferences.enablePackageGrouping = false;
    }

    this.profileCopy.generalPreferences.allowManageAgentAssistants ??= true;

    // Initialize shiftRestrictions if not exists
    if (!this.profileCopy.shiftRestrictions) {
      this.profileCopy.shiftRestrictions = {} as AgentShiftRestrictionsModel;
    }
    if (!this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences) {
      this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences = {} as AgentInShiftBehaviorPreferencesModel;
    }

    if (this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.countOnlyPaidHoursInGoals === undefined ||
      this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.countOnlyPaidHoursInGoals === null) {
      this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.countOnlyPaidHoursInGoals = true;
    }
    if (this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.includeApprovedLeaveInWeeklyGoal === undefined ||
      this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.includeApprovedLeaveInWeeklyGoal === null) {
      this.profileCopy.shiftRestrictions.agentInShiftBehaviorPreferences.includeApprovedLeaveInWeeklyGoal = true;
    }

    if (!this.profileCopy.appPreferences.modules.branchSummaryPortal) {
      this.profileCopy.appPreferences.modules.branchSummaryPortal = {enabled: false};
    }
    if (!this.profileCopy.appPreferences.modules.branchSummaryApp) {
      this.profileCopy.appPreferences.modules.branchSummaryApp = {enabled: false};
    }

    // Initialize agentClockInProviderPreferences only if timekeeping module is enabled
    if (this.splitService.isTimekeepingEnabled()) {
      if (!this.profileCopy.shiftRestrictions.agentClockInProviderPreferences) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences = {} as AgentClockInProviderPreferencesModel;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.provider === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.provider = ClockInResourceProviderType.Default;
      }
      if (!this.profileCopy.shiftRestrictions.agentTimekeepingPreferences) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences = {} as AgentTimekeepingPreferencesModel;
      }
      if (this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.reportFrequency === undefined) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.reportFrequency = TimekeepingFrequencyType.WEEKLY;
      }
      if (this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.requireAgentAcknowledgmentBeforeApproval === undefined) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.requireAgentAcknowledgmentBeforeApproval = false;
      }
      if (this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.blockApprovalOnInfeasibleTimeCards === undefined) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.blockApprovalOnInfeasibleTimeCards = false;
      }
      if (this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.allowManualStopDistanceEdit === undefined) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.allowManualStopDistanceEdit = true;
      }
      if (this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.countPaidTimeFromFirstHeading === undefined) {
        this.profileCopy.shiftRestrictions.agentTimekeepingPreferences.countPaidTimeFromFirstHeading = false;
      }
      this._initializeTimekeepingRiskPreferences();
      this._initializeActualDataDetectionPreferences();
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.enforceResourceBasedLogin === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.enforceResourceBasedLogin = false;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.maxConcurrentClockInResources === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.maxConcurrentClockInResources = 1;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceVisibilityTimeWindowNotBeforeHours === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceVisibilityTimeWindowNotBeforeHours = 3;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceVisibilityTimeWindowNotAfterHours === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceVisibilityTimeWindowNotAfterHours = 3;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.autoAssignPlannedWorkOnClockIn === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.autoAssignPlannedWorkOnClockIn = false;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.autoClockOutOnResourceEnd === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.autoClockOutOnResourceEnd = ClockInOnResourceEndType.Disabled;
      }
      if (this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceScope === undefined) {
        this.profileCopy.shiftRestrictions.agentClockInProviderPreferences.resourceScope = ResourceScopeType.Dedicated;
      }

      if (!this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences = {} as AgentShiftCompensationPreferencesModel;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.enabled === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.enabled = false;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.provider === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.provider = AgentShiftCompensationProviderType.None;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.distanceThreshold === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.distanceThreshold = 40;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.tolerancePercentage === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.tolerancePercentage = 10;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.maxLeaveTimePerDayInMinutes === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.maxLeaveTimePerDayInMinutes = 570;
      }
      if (this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.maxBreakTimePerDayInMinutes === undefined) {
        this.profileCopy.shiftRestrictions.agentShiftCompensationPreferences.maxBreakTimePerDayInMinutes = 30;
      }
    }
  }

  private _initializeTimekeepingRiskPreferences() {
    const tkPref = this.profileCopy.shiftRestrictions.agentTimekeepingPreferences;

    // Risks configuration defaults (millis/meters/percentage)
    if (tkPref.driveTimeThresholdMillis === undefined) {
      tkPref.driveTimeThresholdMillis = 3600000; // 1 hour
    }
    if (tkPref.distanceDeviationThresholdPercentage === undefined) {
      tkPref.distanceDeviationThresholdPercentage = 10;
    }
    if (tkPref.serviceTimeDeviationThresholdPercentage === undefined) {
      tkPref.serviceTimeDeviationThresholdPercentage = 10;
    }
    if (tkPref.driveTimeDeviationThresholdPercentage === undefined) {
      tkPref.driveTimeDeviationThresholdPercentage = 10;
    }
    if (tkPref.adjustedStartTimeDeviationThresholdMillis === undefined) {
      tkPref.adjustedStartTimeDeviationThresholdMillis = 1800000; // 30 minutes
    }
    if (tkPref.adjustedEndTimeDeviationThresholdMillis === undefined) {
      tkPref.adjustedEndTimeDeviationThresholdMillis = 1800000; // 30 minutes
    }
    if (tkPref.adjustedDistanceDeviationThresholdMeters === undefined) {
      tkPref.adjustedDistanceDeviationThresholdMeters = 3000;
    }
    if (tkPref.geoTimeMismatchThresholdMillis === undefined) {
      tkPref.geoTimeMismatchThresholdMillis = 300000; // 5 minutes
    }
    if (tkPref.dwellTimeThresholdMillis === undefined) {
      tkPref.dwellTimeThresholdMillis = 3600000; // 60 minutes
    }

    // Convert millis to minutes for display
    this.timekeepingDisplayValues = {
      driveTimeThresholdMinutes: Math.round(tkPref.driveTimeThresholdMillis / 60000),
      adjustedStartTimeDeviationThresholdMinutes: Math.round(tkPref.adjustedStartTimeDeviationThresholdMillis / 60000),
      adjustedEndTimeDeviationThresholdMinutes: Math.round(tkPref.adjustedEndTimeDeviationThresholdMillis / 60000),
      geoTimeMismatchThresholdMinutes: Math.round(tkPref.geoTimeMismatchThresholdMillis / 60000),
      dwellTimeThresholdMinutes: Math.round(tkPref.dwellTimeThresholdMillis / 60000)
    };
  }

  private _initializeActualDataDetectionPreferences() {
    const tkPref = this.profileCopy.shiftRestrictions.agentTimekeepingPreferences;

    const defaults = {
      stopRadiusMeters: 100.0,
      minStopDurationSeconds: 60,
      minStopThresholdSeconds: 60,
      maxGapDurationSeconds: 300,
      gapClassification: GapClassification.UNKNOWN,
      maxStopSpeedMps: 1.5,
      minStopPoints: 2,
    };

    tkPref.actualDataDetectionPreferences = {
      ...defaults,
      ...(tkPref.actualDataDetectionPreferences || {}),
    };
  }

  private _setPairingOptions() {
    if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.Barcode) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.Barcode];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.ProNumber) {
      this.pairingOptions = [AgentPairingType.ProNumber];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.None) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else if (this.profileCopy.appPreferences.pairingPreferences.validationOption === AgentValidationType.Click) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else {
      this.pairingOptions = angular.copy(Object.values(AgentPairingType));
    }
  }

  private _onDuplicate(profile, agentIds) {
    _.unset(profile, 'id');
    this.agentConfigurationProfilesService.duplicateOne(profile)
      .then((duplicatedProfile: any) => {
        if (agentIds.length) {
          this.onAssignAgentsToProfile(duplicatedProfile.id, agentIds, true);
        }
      })
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('agentConfigurationProfileView', {
    bindings: {
      configurationProfile: '<',
      agent: '<?',
      agentIds: '<?',
      defaultProfileId: '<?',
      selectedTab: '<',
      isAgentProfile: '<?'
    },
    template: require('./agent-configuration-profile-view.html').default,
    controller: agentConfigurationProfileViewCtrl
  });
